import { t } from '../i18n/i18n';
import './Placeholder.scss';

export default function Placeholder({ page, node }) {
  return (
    <section className="placeholder">
      <h1 className="placeholder__title">{t(page)}</h1>
      {node && <p className="placeholder__node">Figma {node}</p>}
    </section>
  );
}
